import { render, staticRenderFns } from "./EmrIndicationList.vue?vue&type=template&id=bbfd830a&scoped=true"
import script from "./EmrIndicationList.vue?vue&type=script&lang=js"
export * from "./EmrIndicationList.vue?vue&type=script&lang=js"
import style0 from "./EmrIndicationList.vue?vue&type=style&index=0&id=bbfd830a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfd830a",
  null
  
)

export default component.exports